export const ATTR_UNIT_ID = 'data-miso-unit-id';
export const ATTR_PRODUCT_ID = 'data-miso-product-id';